import { h, Component } from 'preact';
// import { route } from 'preact-router';
import Toolbar from 'preact-material-components/Toolbar';
import Drawer from 'preact-material-components/Drawer';
import List from 'preact-material-components/List';
import 'preact-material-components/Toolbar/style.css';
import 'preact-material-components/Drawer/style.css';
import 'preact-material-components/List/style.css';

export default class Header extends Component {
	closeDrawer() {
		this.drawer.MDComponent.open = false;
	}

	openDrawer = () => {
		this.drawer.MDComponent.open = true;
	};

	drawerRef = drawer => {
		this.drawer = drawer;
	};

	openGithub = () => {
		window.open('https://github.com/developit');
	};

	render() {
		return (
			<div>
				<Toolbar className="toolbar">
					<Toolbar.Row>
						<Toolbar.Section align-start>
							<Toolbar.Icon menu onClick={this.openDrawer}>menu</Toolbar.Icon>
							<Toolbar.Title>f0x.ca</Toolbar.Title>
						</Toolbar.Section>
						<Toolbar.Section align-end onClick={this.openGithub}>
							<Toolbar.Icon>code</Toolbar.Icon>
							<Toolbar.Title>Github</Toolbar.Title>
						</Toolbar.Section>
					</Toolbar.Row>
				</Toolbar>
				<Drawer.TemporaryDrawer ref={this.drawerRef}>
					<Drawer.TemporaryDrawerContent>
						<List>
							<List.LinkItem href="/" onClick={this.closeDrawer}>
								<List.ItemIcon>home</List.ItemIcon>
								Home
							</List.LinkItem>
							<List.LinkItem href="/profile" onClick={this.closeDrawer}>
								<List.ItemIcon>account_circle</List.ItemIcon>
								Profile
							</List.LinkItem>
						</List>
					</Drawer.TemporaryDrawerContent>
				</Drawer.TemporaryDrawer>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header.js